import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ux-task-plus',
  templateUrl: './task-plus.component.html',
  styleUrls: ['./task-plus.component.less'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskPlusComponent {}
